import React from 'react';
/* Components */
import { Button } from '../Button';

export const SimulationButton = ({ submitEvent }) => {
  return (
    <Button isSimulator={true} color="red" text="Calcola" clickEvent={ submitEvent }/>
  );
}
